import React from "react";
import "./Cast.css";
import img40 from "../assets/img40.jpg";
import img41 from "../assets/img41.jpg";
import img42 from "../assets/img42.jpg";

function Cast() {
    return (
        <div className="main-container">
            {/* ---------- Structures Section ---------- */}
            <div className="structures-container">
                <h2>Structures</h2>
                <ul>
                    <li>
                        Plant size of 230m x 260m - Largest single hanger die casting building of 60,000 Sqm
                    </li>
                </ul>

                <div className="table-wrapper">
                    <table className="custom-table">
                        <thead>
                            <tr>
                                <th className="blue-header">Value Stream</th>
                                <th className="red-header" colSpan="1">Casting</th>
                            </tr>
                            <tr>
                                <th></th>
                                <th className="blue-header">Variants</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td className="bold-text">HT PDC</td>
                                <td>27</td>
                            </tr>
                            <tr className="alt-row">
                                <td className="bold-text">MT PDC</td>
                                <td>89</td>
                            </tr>
                            <tr>
                                <td className="bold-text">GDC</td>
                                <td>215</td>
                            </tr>
                            <tr className="total-row">
                                <td>Total</td>
                                <td>331</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            {/* ---------- Casting Section ---------- */}
            <div className="casting-container">
                {/* PDC Higher Tonnage */}
                <div className="casting-card">
                    <h3 className="card-title">PDC Higher Tonnage</h3>
                    <table className="casting-table">
                        <thead>
                            <tr>
                                <th>Category</th>
                                <th>Casting</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Machines / Cell</td>
                                <td>(2700 T – 3200 T)</td>
                            </tr>
                            <tr>
                                <td>No of Variants</td>
                                <td>27</td>
                            </tr>
                            <tr>
                                <td>Dies</td>
                                <td>35</td>
                            </tr>
                        </tbody>
                    </table>

                    {/* Logos */}
                    <div className="parts">
                        <img src={img40} alt="SCL" />
                    </div>
                </div>

                {/* PDC Medium Tonnage */}
                <div className="casting-card">
                    <h3 className="card-title">PDC Medium Tonnage</h3>
                    <table className="casting-table">
                        <thead>
                            <tr>
                                <th>Category</th>
                                <th>Casting</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Machines / Cell</td>
                                <td>(660 T – 1400 T)</td>
                            </tr>
                            <tr>
                                <td>No of Variants</td>
                                <td>89</td>
                            </tr>
                            <tr>
                                <td>Dies</td>
                                <td>130</td>
                            </tr>
                        </tbody>
                    </table>

                    <div className="parts">
                        <img src={img41} alt="SCL" />
                    </div>
                </div>

                {/* GDC */}
                <div className="casting-card">
                    <h3 className="card-title">GDC</h3>
                    <table className="casting-table">
                        <thead>
                            <tr>
                                <th>Category</th>
                                <th>Casting</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Machines / Cell</td>
                                <td>–</td>
                            </tr>
                            <tr>
                                <td>No of Variants</td>
                                <td>215</td>
                            </tr>
                            <tr>
                                <td>Dies</td>
                                <td>
                                    Dies : 170 <br />
                                    Core : 120
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <div className="parts">
                        <img src={img42} alt="SCL" />

                    </div>
                </div>
            </div>
        </div>
    );
}

export default Cast;
